// intervalManager.js
let globalIntervalId = null;

export const setGlobalInterval = (intervalId) => {
  globalIntervalId = intervalId;
};

export const clearGlobalInterval = () => {
  if (globalIntervalId) {
    clearInterval(globalIntervalId);
    globalIntervalId = null;
  }
};
